import { Fragment } from "react";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { setChatWallpaper } from "../../ReduxToolkit/Reducers/TemplateCustomizerReducers";
import { dynamicImage, Image } from "../../Utils";

const ChatWallpaper = () => {
  const dispatch = useAppDispatch();
  const { chatWallpaper } = useAppSelector((state) => state.templateCustomizer);

  return (
    <Fragment>
      <h5>Chat wallpaper</h5>
      <ul className="wallpaper">
        {chatWallpaper.map((item, index) => (
          <Fragment key={index}>
            {item.wallpaperClass ? (
              <li className={`${item.class} ${item.wallpaperClass} ${item.active ? "active" : ""}`} onClick={() => dispatch(setChatWallpaper(item))} />
            ) : (
              <li className={`${item.class} ${item.active ? "active" : ""}`} style={{ backgroundImage: `url(${dynamicImage(`wallpaper/${item.wallpaperImage}.jpg`)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }} onClick={() => dispatch(setChatWallpaper(item))}>
                <Image className="bg-img" src={dynamicImage(`wallpaper/${item.wallpaperImage}.jpg`)} alt="Avatar" style={{ display: "none" }} />
              </li>
            )}
          </Fragment>
        ))}
      </ul>
    </Fragment>
  );
};

export default ChatWallpaper;
